import React, { useEffect, useState } from 'react'
import { Controller } from 'react-hook-form'
import { InputMain } from '@/components/ui/inputs'
import Select from 'react-select'

import { SvgMinusCircleIcon } from '@/components/icons'
import { SvgPlugCircleIcon } from '@/components/icons'
import { getParent } from '@/firebase/parent'
import Image from 'next/image'
import { getStudentForOption } from '@/firebase/students'

const DefaultRoles = [
  { label: 'School', value: 'school' },
  { label: 'Student', value: 'student' },
  { label: 'Parent', value: 'parent' },
]

interface Props {
  control: any
  fields: any
  roles?:
    | {
        label: string
        value: string
      }[]
    | undefined
  append: any
  remove: any
  errors: any
}

const SelectRole: React.FC<Props> = ({
  control,
  fields,
  roles = DefaultRoles,
  append,
  remove,
  errors,
}) => {
  const [option, setOption] = useState([])

  const customStyles = {
    avatar: {
      width: '40px',
      height: '40px',
      borderRadius: '50%',
      marginRight: '10px',
    },
    name: {
      fontWeight: 'bold',
      fontSize: '16px',
      marginBottom: '2px',
    },
    username: {
      fontSize: '14px',
      color: '#666',
    },
  }

  const handleChange = (e) => {
    if (e?.value === 'student') {
      getParent().then((res) => {
        setOption(res)
      })
    } else if (e?.value === 'parent') {
      getStudentForOption().then((res) => {
        setOption(res)
      })
    } else if (e?.value === 'school') {
      getParent().then((res) => {
        setOption(res)
      })
    }
  }
  const CustomComponent = (props) => {
    const { innerProps, innerRef, data, isSelected } = props
    return (
      <div
        ref={innerRef}
        {...innerProps}
        style={{
          display: 'flex',
          alignItems: 'center',
          padding: '8px',
          color: '#333',
          background: isSelected ? '#F9FAFB' : '',
        }}
        className="hover:bg-[#F9FAFB] cursor-pointer"
      >
        <Image
          src={data?.photo}
          alt={data?.name}
          style={customStyles.avatar}
          width={40}
          height={40}
        />
        <div>
          <div style={customStyles.name}>{data?.name}</div>
          <div style={customStyles.username}>@{data?.username}</div>
        </div>
      </div>
    )
  }

  return (
    <>
      <InputMain className="sm:gap-2 sm:border-b-0">
        <InputMain.Label label="Role" htmlFor="role" className="text-left" />
        <div className="">
          <Controller
            name="role"
            control={control}
            render={({ field: { onChange, value } }) => {
              return (
                <Select
                  id="role"
                  name="role"
                  options={roles}
                  onChange={(e) => {
                    onChange(e)
                    handleChange(e)
                  }}
                  className="border border-v8-line rounded-lg select-inner-block text-left"
                  placeholder="Select-"
                  value={value}
                  theme={(theme) => ({
                    ...theme,
                    colors: {
                      ...theme.colors,
                      primary25: '#C7D7FE',
                      primary: '#444CE7',
                    },
                  })}
                />
              )
            }}
            rules={{ required: true }}
          />
        </div>
        {errors?.['role']?.message && (
          <div className="mt-2 text-xs text-red-600 text-start">
            <span className="text-xs text-red-600 ">
              {errors['role']?.message}
            </span>
          </div>
        )}
      </InputMain>
      {!!fields?.length && (
        <InputMain className="sm:gap-2 sm:border-b-0">
          {/*<InputMain.Label*/}
          {/*  label="Connect to childs/parent account"*/}
          {/*  htmlFor="connects"*/}
          {/*  className="text-left"*/}
          {/*/>*/}
          <div className="">
            {fields.map((field, idx) => (
              <div key={field.id} className="flex gap-2 my-2">
                <div className="w-11/12">
                  <Controller
                    name={`connects.${idx}`}
                    control={control}
                    render={({ field }) => {
                      return (
                        <Select
                          id="connects"
                          name={`connects.${idx}`}
                          options={option}
                          onChange={(e) => {}}
                          components={{ Option: CustomComponent }}
                          className="border border-v8-line rounded-lg select-inner-block text-left"
                          placeholder="Select-"
                          {...field}
                          theme={(theme) => ({
                            ...theme,
                            colors: {
                              ...theme.colors,
                              primary25: '#C7D7FE',
                              primary: '#444CE7',
                            },
                          })}
                          maxMenuHeight={200}
                          styles={{
                            menu: (base) => ({
                              ...base,
                              padding: '5px 10px',
                            }),
                            menuList: (base) => ({
                              ...base,
                              '::-webkit-scrollbar': {
                                width: '10px',
                                height: '0px',
                              },
                              '::-webkit-scrollbar-track': {
                                background: '#f1f1f1',
                                borderRadius: 15,
                              },
                              '::-webkit-scrollbar-thumb': {
                                background: '#D5D9EB',
                                borderRadius: 15,
                              },
                            }),
                          }}
                        />
                      )
                    }}
                  />
                </div>
                <div className="w-2 flex items-center ">
                  <button type="button" onClick={() => remove(idx)}>
                    <SvgMinusCircleIcon />
                  </button>
                </div>
              </div>
            ))}
          </div>
        </InputMain>
      )}
    </>
  )
}

export default SelectRole
